<template>
<div>
    <div style="border:dashed 3px #ccc; color:#bbb; padding:10px; border-radius:8px">
        New Component
    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        item: Object,
    },

    computed: {
        property1() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    },

    // watch: {
    //     item: {
    //         handler: function (val, oldVal) { /* ... */ },
    //         deep: true
    //     },
    // }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// Template.vue?19cef2c9